import React from 'react'
import { Link } from 'react-router-dom'


const Header = () => {
  return (
    <header id="header">
        <Link to="/" className="logo"></Link>
        <nav>
          <ul>
            <li><a href="https://www.facebook.com/Antibully-Clothing-Company-1488950677848741/" target="_blank"><i className="fa fa-facebook"></i></a></li>
            <li><a href="https://www.instagram.com/antibullyclothing/" target="_blank"><i className="fa fa-instagram"></i></a></li>
            {/* <li><a href="https://twitter.com/comfybebe" target="_blank"><i className="fa fa-twitter"></i></a></li> */}
            <li><a href="https://www.etsy.com/shop/ComfyBebe?ref=l2-shopheader-name" target="_blank"><i className="fa fa-etsy"></i></a></li>
          </ul>
        </nav>
    </header>
  )
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js